import { NgModule } from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { AdItemComponent } from './ad-item.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
	declarations: [AdItemComponent],
	imports: [SharedModule, NgbCarouselModule, ButtonModule],
	exports: [AdItemComponent],
})
export class AdItemModule {}
